import { z } from 'zod';
/**
 * Delete Artifact Request Schema
 * DELETE /api/v2/artifacts/:id
 */ export const DeleteArtifactRequestSchema = z.object({});
/**
 * Delete Artifact Response Schema
 * DELETE /api/v2/artifacts/:id
 */ export const DeleteArtifactResponseSchema = z.object({
    success: z.boolean()
});

//# sourceMappingURL=delete-artifact.schema.js.map